import { Stack, Box, Typography, Divider } from "@mui/material";
import { useTranslation } from "react-i18next";
type WordCountProps = {
  totalWords: number;
  totalUniqueWords: number;
  totalUniqueNonCommonWords: number;
};
export const WordCount = ({
  totalWords,
  totalUniqueWords,
  totalUniqueNonCommonWords
}: WordCountProps) => {
  const {
    t
  } = useTranslation();
  return <Stack direction="row" bgcolor="background.paper" border={1} borderColor="border" borderRadius={2} width="100%" p={2} boxSizing="border-box" data-sentry-element="Stack" data-sentry-component="WordCount" data-sentry-source-file="WordCount.tsx">
      <Box flex={1} data-sentry-element="Box" data-sentry-source-file="WordCount.tsx">
        <Typography variant="body2" color="text.secondary" data-sentry-element="Typography" data-sentry-source-file="WordCount.tsx">
          {t("content.itemEditMetaWords")}
        </Typography>
        <Typography variant="h4" color="text.primary" fontWeight={600} data-sentry-element="Typography" data-sentry-source-file="WordCount.tsx">
          {totalWords}
        </Typography>
      </Box>
      <Divider orientation="vertical" variant="middle" flexItem sx={{
      mx: 2,
      my: 0,
      borderRightWidth: "2px"
    }} data-sentry-element="Divider" data-sentry-source-file="WordCount.tsx" />
      <Box flex={1} data-sentry-element="Box" data-sentry-source-file="WordCount.tsx">
        <Typography variant="body2" color="text.secondary" data-sentry-element="Typography" data-sentry-source-file="WordCount.tsx">
          {t("content.itemEditMetaUniqueWords")}
        </Typography>
        <Typography variant="h4" color="text.primary" fontWeight={600} data-sentry-element="Typography" data-sentry-source-file="WordCount.tsx">
          {totalUniqueWords}
        </Typography>
      </Box>
      <Divider orientation="vertical" variant="middle" flexItem sx={{
      mx: 2,
      my: 0,
      borderRightWidth: "2px"
    }} data-sentry-element="Divider" data-sentry-source-file="WordCount.tsx" />
      <Box flex={1} data-sentry-element="Box" data-sentry-source-file="WordCount.tsx">
        <Typography variant="body2" color="text.secondary" data-sentry-element="Typography" data-sentry-source-file="WordCount.tsx">
          {t("content.itemEditMetaNonFillerWords")}
        </Typography>
        <Typography variant="h4" color="text.primary" fontWeight={600} data-sentry-element="Typography" data-sentry-source-file="WordCount.tsx">
          {totalUniqueNonCommonWords}
        </Typography>
      </Box>
    </Stack>;
};